module.exports = __webpack_public_path__ + "static/media/outsite-desc@2x.113a98ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/outsite-desc@2x.png
// module id = 1023
// module chunks = 0